import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const affiliateManagersSelector = createFeatureSelector<IState>('affiliateManagers');
export const getAffiliateManagersSelector = createSelector(affiliateManagersSelector, (state: IState) => state); 
export const getAffiliateManagerSelector = createSelector(affiliateManagersSelector, (state: IState) => state.selectedItem); 
